import DisconnectedIllustration from '@/assets/f5-illustrations/disconnected.svg';
import ServerErrorIllustration from '@/assets/f5-illustrations/server-error.svg';

export type IllustrationType = 'disconnected' | 'server-error';

export type IllustrationSize = 'xs' | 'small' | 'medium' | 'large' | 'xl';

export const IllustrationMap: Record<IllustrationType, string> = {
  disconnected: DisconnectedIllustration,
  'server-error': ServerErrorIllustration,
};

export const IllustrationSizes: Record<IllustrationSize, number> = {
  xs: 64,
  small: 96,
  medium: 164,
  large: 288,
  xl: 464,
};
